import { render, staticRenderFns } from "./TeamsIntegrationCard.vue?vue&type=template&id=670bb218&scoped=true"
import script from "./TeamsIntegrationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamsIntegrationCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TeamsIntegrationCard.vue?vue&type=style&index=0&id=670bb218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670bb218",
  null
  
)

export default component.exports